import React, { Component } from 'react';
import Dropdown from './controls/Dropdown';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import FontAwsomeCustom from './Extension/FontAwsomeCustom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FormHeader from '../assets/images/contentcreators_header.jpg';
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import  RenderString  from './utils/Utils';

library.add(fab, fas, far);


function ModalContent(props) {
    if (props.isFormValid) {
        return (<React.Fragment>
            <Modal.Header>
                <Modal.Title>
                    <h3>Thank You</h3>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h4>We&apos;ll be in touch</h4>
                <p>Thank you for showing an interest in Codemasters Creators Program, we&apos;ve received your information and our partners at Fourth Floor Creative will be in touch shortly.</p>
            </Modal.Body>
        </React.Fragment>);
    } else {
        return(<React.Fragment>
            <Modal.Header>
                <Modal.Title>
                    <h3>Please review the following:</h3>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ul className="Modal__list">
                    {props.errors.map((msg, key) => {
                        return <li key={key}>{msg}</li>
                    })}
                </ul>
            </Modal.Body>
        </React.Fragment>);
    }
}

export class InfluencerForm extends Component {

    constructor(state, props) {
        super(state);
        this.state = {
            name: '',
            emailAddress: '',
            youtube: '',
            twitch: '',
            mixer: '',
            facebook: '',
            twitter: '',
            instagram: '',
            hasPlayedCodemasters: 'false',
            hasPlayedCodemastersText: '',
            hasPlayedRacingGame: 'false',
            hasPlayedRacingGameText: '',
            referalSource: '',
            referalSourceOtherText: '',
            isTermsAndConditions: false,
            referalCollection: '',
            isFormValid: false,
            formErrors: [],
            showModal: false,
        }
    }

    invalidName = 'Name with a maximum length of 30 characters and at least one letter is required.';
    invalidEmail = 'Valid email address required.';
    invalidUrl = 'Social media url must be in a valid format';
    invalidYoutubeUrl = 'Valid Youtube url is required';
    invalidTwitchUrl = 'Valid Twitch url is required';
    invalidMixerUrl = 'Valid Mixer url is required';
    invalidFacebookUrl = 'Valid Facebook url is required';
    invalidTwitterUrl = 'Valid Twitter url is required';
    invalidInstagramUrl = 'Valid Instagram url is required';
    invalidTUrl = 'The url is invalid';
    oneUrlRequired = 'At least one social media url is required.';
    invalidCodemasters = 'Tell us what Codemasters titles you\'ve played before.';
    invalidRacingGames = 'Tell us what racing game titles you\'ve played before.';
    invalidReferal = 'Tell us how did you find out about us.';
    invalidTermsAndConditions = 'Accept the terms and conditions and Privacy Policy';
    userNameRegEx = /[a-zA-z]+/;
    emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    urlRegEx = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
    youtubeRegEx = /^([Hh][Tt][Tt][Pp][Ss]:\/\/([Ww][Ww][Ww].)?[Yy][Oo][Uu][Tt][Uu][Bb][Ee].[Cc][Oo][Mm])+[\S]+$/;
    twitchRegEx = /^([Hh][Tt][Tt][Pp][Ss]:\/\/([Ww][Ww][Ww].)?[Tt][Ww][Ii][Tt][Cc][Hh].[Tt][Vv]\/)+[\S]+$/;
    mixerRegEx = /^([Hh][Tt][Tt][Pp][Ss]:\/\/([Ww][Ww][Ww].)?[Mm][Ii][Xx][Ee][Rr].[Cc][Oo][Mm]\/)+[\S]+$/;
    facebookRegEx = /^([Hh][Tt][Tt][Pp][Ss]:\/\/([Ww][Ww][Ww].)?[Ff][Aa][Cc][Ee][Bb][Oo][Oo][Kk].[Cc][Oo][Mm]\/)+[\S]+$/;
    twitterRegEx = /^([Hh][Tt][Tt][Pp][Ss]:\/\/([Ww][Ww][Ww].)?[Tt][Ww][Ii][Tt][Tt][Ee][Rr].[Cc][Oo][Mm]\/)+[\S]+$/;
    instagramRegEx = /^([Hh][Tt][Tt][Pp][Ss]:\/\/([Ww][Ww][Ww].)?[Ii][Nn][Ss][Tt][Aa][Gg][Rr][Aa][Mm].[Cc][Oo][Mm]\/)+[\S]+$/;
    
    onSubmit = (e) => {
        this.validateForm();
        e.preventDefault();

    }

    processSubmit = () => {
        if (this.state.isFormValid) {
            axios.post('/api/influencer', {
                name: this.state.name,
                emailAddress: this.state.emailAddress,
                youtube: this.state.youtube,
                twitch: this.state.twitch,
                mixer: this.state.mixer,
                facebook: this.state.facebook,
                twitter: this.state.twitter,
                instagram: this.state.instagram,
                hasPlayedCodemasters: this.state.hasPlayedCodemasters,
                hasPlayedCodemastersText: this.state.hasPlayedCodemastersText,
                hasPlayedRacingGame: this.state.hasPlayedRacingGame,
                hasPlayedRacingGameText: this.state.hasPlayedRacingGameText,
                referalSource: this.state.referalSource,
                referalSourceOtherText: this.state.referalSourceOtherText,
                IsTermsAndConditions: this.state.isTermsAndConditions
            })
                .then(() => {
                    this.setState({ showModal: true })
                })
                .catch(err => {
                    this.setState({ showModal: true, isFormValid: false, formErrors: this.handleApiResponse(err.response) });
                });
        } else {
            this.setState({ showModal: true, formErrors: this.state.formErrors })
        }
    }

    closeForm = () => {
        this.setState({ showModal: false }, () => {
            if (this.state.isFormValid) { window.location.reload(); }
        });
    }

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value });
        this.validateInput(e);

    }

    validateInput = (e) => {
        let valid = false;
        switch (e.target.name) {
            case 'name':
                valid = e.target.value.trim() !== '' && e.target.value.trim().length <= 30 && this.userNameRegEx.test(String(e.target.value).toLocaleLowerCase().trim());
                break;
            case 'emailAddress':
                valid = e.target.value.trim() !== '' && this.emailRegEx.test(String(e.target.value).toLowerCase().trim());
                break;
            case 'youtube':
                valid = e.target.value.trim() === '' || this.youtubeRegEx.test(String(e.target.value).toLowerCase().trim());
                break;
            case 'twitch':
                valid = e.target.value.trim() === '' || this.twitchRegEx.test(String(e.target.value).toLowerCase().trim());
                break;
            case 'mixer':
                valid = e.target.value.trim() === '' || this.mixerRegEx.test(String(e.target.value).toLowerCase().trim());
                break;
            case 'facebook':
                valid = e.target.value.trim() === '' || this.facebookRegEx.test(String(e.target.value).toLowerCase().trim());
                break;
            case 'twitter':
                valid = e.target.value.trim() === '' || this.twitterRegEx.test(String(e.target.value).toLowerCase().trim());
                break;
            case 'instagram':
                valid = e.target.value.trim() === '' || this.instagramRegEx.test(String(e.target.value).toLowerCase().trim());
                break;
            case 'hasPlayedCodemasters':
                var textControl = document.getElementById("hasPlayedCodemastersText");
                valid = e.target.value === 'true' ? textControl.value.trim() !== '' : true;
                e.target = textControl;
                break;
            case 'hasPlayedCodemastersText':
                valid = this.state.hasPlayedCodemasters === 'true' ? e.target.value.trim() !== '' : true ;
                break;
            case 'hasPlayedRacingGame':
                textControl = document.getElementById("hasPlayedRacingGameText");
                valid = e.target.value === 'true' ? textControl.value.trim() !== '' : true;
                e.target = textControl;
                break;
            case 'hasPlayedRacingGameText':
                valid = this.state.hasPlayedRacingGame === 'true' ? e.target.value.trim() !== '' : true;
                break;
            case 'referalSource':
                valid = e.target.value > 0;
                break;
            case 'referalSourceOtherText':
                valid = e.target.value.trim() !== '' && this.state.referalSource === "4";
                break;
            default:
                valid = true;
                break;
        }
        if (!valid) {
            e.target.classList.add("is-invalid");
        } else {
            if (e.target.classList.contains("is-invalid")) { e.target.classList.remove("is-invalid"); }
        }
    }

    validateForm = () => {
        let validForm = true;
        let errorMsg = [];
        if (this.state.name.trim() === '' || this.state.name.trim() > 30 || !this.userNameRegEx.test(String(this.state.name).toLocaleLowerCase().trim())) {
            validForm = false;
            errorMsg.push(this.invalidName);
        }
        if (this.state.emailAddress.trim() === '' || !this.emailRegEx.test(String(this.state.emailAddress).trim().toLowerCase())) {
            validForm = false;
            errorMsg.push(this.invalidEmail);         
        }
        if (this.state.youtube.trim() !== '' && !this.youtubeRegEx.test(String(this.state.youtube).toLocaleLowerCase().trim()))
        {
            validForm = false;
            errorMsg.push(this.invalidYoutubeUrl);
        }
        if (this.state.twitch.trim() !== '' && !this.twitchRegEx.test(String(this.state.twitch).toLocaleLowerCase().trim())) {
            validForm = false;
            errorMsg.push(this.invalidTwitchUrl);
        }
        if (this.state.mixer.trim() !== '' && !this.mixerRegEx.test(String(this.state.mixer).toLocaleLowerCase().trim())) {
            validForm = false;
            errorMsg.push(this.invalidMixerUrl);
        }
        if (this.state.facebook.trim() !== '' && !this.facebookRegEx.test(String(this.state.facebook).toLocaleLowerCase().trim())) {
            validForm = false;
            errorMsg.push(this.invalidFacebookUrl);
        }
        if (this.state.twitter.trim() !== '' && !this.twitterRegEx.test(String(this.state.twitter).toLocaleLowerCase().trim())) {
            validForm = false;
            errorMsg.push(this.invalidTwitterUrl);
        }
        if (this.state.instagram.trim() !== '' && !this.instagramRegEx.test(String(this.state.instagram).toLocaleLowerCase().trim())) {
            validForm = false;
            errorMsg.push(this.invalidInstagramUrl);
        }

        if (this.state.youtube.trim() === '' &&
            this.state.twitch.trim() === '' &&
            this.state.mixer.trim() === ''
            && this.state.facebook.trim() === '' &&
            this.state.twitter.trim() === '' &&
            this.state.instagram.trim() === '') {
            validForm = false;
            errorMsg.push(this.oneUrlRequired);
        }
        if (this.state.hasPlayedCodemasters === 'true' && this.state.hasPlayedCodemastersText.trim() === '') {
            validForm = false;
            errorMsg.push(this.invalidCodemasters);
        }
        if (this.state.hasPlayedRacingGame === 'true' && this.state.hasPlayedRacingGameText.trim() === '') {
            validForm = false;
            errorMsg.push(this.invalidRacingGames);
        }
        if (this.state.referalSource === '' || (this.state.referalSource === "4" && this.state.referalSourceOtherText.trim() === '')) {
            validForm = false;
            errorMsg.push(this.invalidReferal);
        }
        if (!this.state.isTermsAndConditions) {
            validForm = false;
            errorMsg.push(this.invalidTermsAndConditions);
        }

        this.setState({ isFormValid: validForm, formErrors: errorMsg }, () =>  this.processSubmit() );
    }

    handleApiResponse = (response) => {
        let msgs = [];
        try {
            response.data.validationFieldErrors.map((r) => {
                return r.errors.map((e) => { msgs.push(e) })
            });
        } catch{
            msgs.push("Something went wrong while trying to submit your request");
        } 
        return msgs;
    }
    
    render() {
        return (
            <React.Fragment>
                <Modal show={this.state.showModal} centered>
                    <ModalContent isFormValid={this.state.isFormValid} errors={this.state.formErrors} />
                    <Modal.Footer>
                        <button type="submit" className="btn-hollow form__submit--btn" onClick={this.closeForm}>Close</button>
                    </Modal.Footer>
                </Modal>
                <div className="row">
                    <div className="col-12">
                        <div className="form__header">
                            <img src={FormHeader} alt="form-header" />
                        </div>
                        <form className="form" onSubmit={this.onSubmit}>
                            <div className="form__description">
                                <h1>Codemasters &lsquo;Racing Ahead&rsquo; Content Creators&rsquo; Program</h1>
                                <p>Calling all Content Creators! Get in touch and start making videos on some of the world&apos;s best racing titles.</p>
                                <p>At Codemasters, we want to make it as easy as possible for all talented content creators and streamers around the world to work with us on our upcoming racing titles. Want to get involved? Simply fill in the form below with your details and, if accepted, we&apos;ll be in touch</p>
                                <p>Once confirmed, the &lsquo;Racing Ahead&rsquo; program will enable you to get early behind-the-scenes access, game codes and some other surprises along the way</p>
                                <br />
                                <h4>SIMPLY FILL OUT THE FORM TO GET STARTED</h4>
                                <p>Let us know a little more about you and we&apos;ll be in touch.</p>
                            </div>
                            <div className="form-group">
                                <label htmlFor="name">Preferred Name*</label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="nameGroupPrepend"><FontAwesomeIcon icon="user" /></span>
                                    </div>
                                    <input type="text" className="form-control" id="name" name="name" placeholder="Name/Gametag/Alias" aria-describedby="nameGroupPrepend"
                                        value={this.state.name}
                                        onChange={this.onChange}
                                        onTouchStart={this.validateInput} />
                                    <div className="invalid-feedback">
                                        <RenderString string={this.invalidName} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="emailAddress">Email Address*</label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="emailGroupPrepend"><FontAwesomeIcon icon="envelope" /></span>
                                    </div>
                                    <input type="text" className="form-control" id="emailAddress" name="emailAddress" placeholder="How should we stay in touch" aria-describedby="emailGroupPrepend"
                                        value={this.state.emailAddress}
                                        onChange={this.onChange} />
                                    <div className="invalid-feedback">
                                        <RenderString string={this.invalidEmail} />
                                    </div>
                                </div>
                            </div>
                            <br />
                            <br />
                            <div className="form-group">
                                <label htmlFor="youtube">Youtube Channel Link</label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="youtubeGroupPrepend"><FontAwesomeIcon icon={["fab", "youtube"]} /></span>
                                    </div>
                                    <input type="text" className="form-control" id="youtube" name="youtube" placeholder="https://www.youtube.com/" aria-describedby="youtubeGroupPrepend"
                                        value={this.state.youtube}
                                        onChange={this.onChange} />  
                                    <div className="invalid-feedback">
                                        <RenderString string={this.invalidYoutubeUrl} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="twitch">Twitch Channel Link</label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="twitchGroupPrepend"><FontAwesomeIcon icon={["fab", "twitch"]} /></span>
                                    </div>
                                    <input type="text" className="form-control" id="twitch" name="twitch" placeholder="https://www.twitch.tv/" aria-describedby="twitchGroupPrepend"
                                        value={this.state.twitch}
                                        onChange={this.onChange} />
                                    <div className="invalid-feedback">
                                        <RenderString string={this.invalidTwitchUrl} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="mixer">Mixer Channel Link</label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text form__icon--custom" id="mixerGroupPrepend"><FontAwsomeCustom /></span>
                                    </div>
                                    <input type="text" className="form-control" id="mixer" name="mixer" placeholder="https://mixer.com/" aria-describedby="mixerGroupPrepend"
                                        value={this.state.mixer}
                                        onChange={this.onChange} />
                                    <div className="invalid-feedback">
                                        <RenderString string={this.invalidMixerUrl} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="facebook">Facebook Channel Link</label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="facebookGroupPrepend"><FontAwesomeIcon icon={["fab", "facebook"]} /></span>
                                    </div>
                                    <input type="text" className="form-control" id="facebook" name="facebook" placeholder="https://www.facebook.com/" aria-describedby="facebookGroupPrepend"
                                        value={this.state.facebook}
                                        onChange={this.onChange} />
                                    <div className="invalid-feedback">
                                        <RenderString string={this.invalidFacebookUrl} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="twitter">Twitter Channel Link</label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="twitterGroupPrepend"><FontAwesomeIcon icon={["fab", "twitter"]} /></span>
                                    </div>
                                    <input type="text" className="form-control" id="twitter" name="twitter" placeholder="https://twitter.com/" aria-describedby="twitterGroupPrepend"
                                        value={this.state.twitter}
                                        onChange={this.onChange} />
                                    <div className="invalid-feedback">
                                        <RenderString string={this.invalidTwitterUrl} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="instagram">Instagram Channel Link</label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="instagramGroupPrepend"><FontAwesomeIcon icon={["fab", "instagram"]} /></span>
                                    </div>
                                    <input type="text" className="form-control" id="instagram" name="instagram" placeholder="https://www.instagram.com/" aria-describedby="instagramGroupPrepend"
                                        value={this.state.instagram}
                                        onChange={this.onChange} formNoValidate />
                                    <div className="invalid-feedback">
                                        <RenderString string={this.invalidInstagramUrl} />
                                    </div>
                                </div>
                            </div>
                            <br />
                            <br />
                            <label className="form-check-label form-row" >
                                Have you ever played a Codemasters title before?*
                        </label>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="hasPlayedCodemasters" id="hasPlayedCodemastersYes"
                                    value="true"
                                    checked={this.state.hasPlayedCodemasters === 'true'}
                                    onChange={this.onChange} />
                                <label className="form-check-label" htmlFor="hasPlayedCodemastersYes">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="hasPlayedCodemasters" id="hasPlayedCodemastersNo"
                                    value="false"
                                    checked={this.state.hasPlayedCodemasters === 'false'}
                                    onChange={this.onChange} />
                                <label className="form-check-label" htmlFor="hasPlayedCodemastersNo">No</label>

                            </div>
                            <div className="form-group">
                                <label htmlFor="hasPlayedCodemastersText">If yes, which titles? Have you created content for them?</label>
                                <textarea className="form-control" id="hasPlayedCodemastersText" name="hasPlayedCodemastersText" placeholder="Tell us more about what you&apos;ve played"
                                    value={this.state.hasPlayedCodemastersText}
                                    onChange={this.onChange}
                                    rows="3" />
                                <div className="invalid-feedback">
                                    <RenderString string={this.invalidCodemasters} />
                                </div>
                            </div>
                            <br />
                            <br />
                            <label className="form-check-label form-row" >
                                Have you ever played a racing game before? (if not already included in the above)*
                        </label>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="hasPlayedRacingGame" id="hasPlayedRacingGameYes"
                                    value="true"
                                    checked={this.state.hasPlayedRacingGame === 'true'}
                                    onChange={this.onChange} />
                                <label className="form-check-label" htmlFor="hasPlayedCodemastersYes">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="hasPlayedRacingGame" id="hasPlayedRacingGameNo"
                                    value="false"
                                    checked={this.state.hasPlayedRacingGame === 'false'}
                                    onChange={this.onChange} />
                                <label className="form-check-label" htmlFor="hasPlayedCodemastersNo">No</label>
                            </div>
                            <div className="form-group">
                                <label htmlFor="hasPlayedRacingGameText">If yes, which titles? Have you created content for them?</label>
                                <textarea className="form-control" id="hasPlayedRacingGameText" name="hasPlayedRacingGameText" placeholder="Tell us more about what you&apos;ve played"
                                    value={this.state.hasPlayedRacingGameText}
                                    onChange={this.onChange}
                                    rows="3" />
                                <div className="invalid-feedback">
                                    <RenderString string={this.invalidRacingGames} />
                                </div>
                            </div>
                            <br />
                            <br />
                            <Dropdown values={this.state.referalCollection} onChange={this.onChange} validationMsg={this.invalidReferal} />
                            <br />
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="checkbox" name="isTermsAndConditions" id="isTermsAndConditions"
                                    value={this.state.isTermsAndConditions}
                                    checked={this.state.isTermsAndConditions}
                                    onChange={this.onChange} />
                                <label className="form-check-label" htmlFor="isTermsAndConditions">I understand that by submitting this form and checking this box I have read the <a href={this.props.settings.termsAndCond} target="_blank"><u>Terms &amp; Conditions</u></a>&nbsp;
                                    and <a href={this.props.settings.privacyPolicy} target="_blank"><u>Privacy Policy</u></a> and hereby give my consent to use the information I have provided for the Codemasters Racing Ahead Creators Program.</label>
                            </div>
                            <br />
                            <div className="form__submit">
                                <button type="submit" className="btn-hollow form__submit--btn">Submit Form</button>
                            </div>
                        </form>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default InfluencerForm
